<script>
export default {
    name: "Modal",

    props: {
        content: String,
    },

    mounted() {
        document.documentElement.style.overflowY = "hidden"
        document.documentElement.style.height = "100vh"
    },

    destroyed() {
        this.handleClose();
    },

    methods: {
        handleClose() {
            document.documentElement.style.overflowY = "auto"
            document.documentElement.style.height = "auto"
        },
    }
}
</script>

<template>
    <div class="vue-modal">
        <button type="button" class="close-button" @click="$emit('close')"><span class="visually-hidden">Sluiten</span></button>
        <div v-html="content" class="modal-content"></div>
    </div>
</template>